import { CalculatorIcon } from '@heroicons/react/24/outline';
import type { ToolManifest } from '../types';

const manifest: ToolManifest = {
  slug: 'yasal-yukumluluk-hesaplayici',
  href: '/araclar/yasal-yukumluluk-hesaplayici',
  title: 'Yasal Yükümlülük Hesaplayıcı',
  shortLabel: 'Yasal Yükümlülük',
  eyebrow: '6331 · 33212 sayılı 2026 yönetmelik uyumlu',
  description:
    'Çalışan sayısı + tehlike sınıfı + (opsiyonel) yıl içinde yeni alım sayısı verince iş güvenliği uzmanı sınıfı, çalışan temsilcisi, İSG kurulu, eğitim periyotları, işe özgü risk modülü metodolojisi ve yıllık eğitim adam-saat tahminini mevzuat referanslı tek formda hesaplar.',
  bullets: [
    'İş güvenliği uzmanı sınıfı (A/B/C) + dayanağı',
    'Çalışan temsilcisi tablosu (28750 Md 7)',
    'İşe özgü risk eğitimi (2/3/4 saat) + metodoloji',
    'Yıllık eğitim adam-saat (yüz yüze + esnek ayrı)',
  ],
  audience: 'OSGB · iş güvenliği uzmanı · İşveren · İK',
  icon: CalculatorIcon,
  mevzuat: [
    { no: '6331', ad: 'İş Sağlığı ve Güvenliği Kanunu' },
    { no: '33212', ad: 'Çalışanların İş Sağlığı ve Güvenliği Eğitimlerinin Usul ve Esasları Hakkında Yönetmelik (2026)' },
    { no: '28512', ad: 'Risk Değerlendirmesi / İş Güvenliği Uzmanları Yönetmeliği', madde: 'Md 7, 12' },
    { no: '28532', ad: 'İş Sağlığı ve Güvenliği Kurulları Yönetmeliği', madde: 'Md 4, 9' },
    { no: '28750', ad: 'Çalışan Temsilcisi Tebliği', madde: 'Md 7' },
    { no: '28681', ad: 'İşyerlerinde Acil Durumlar Yönetmeliği', madde: 'Md 13' },
  ],
  imzaTipi: 'YOK',
  raporlama: 'YOK',
  faqs: [
    {
      question: 'Hesaplama hangi kanun ve yönetmeliklere dayanıyor?',
      answer:
        '6331 sayılı İş Sağlığı ve Güvenliği Kanunu, 02.04.2026 tarihli 33212 sayılı Çalışanların İş Sağlığı ve Güvenliği Eğitimlerinin Usul ve Esasları Hakkında Yönetmelik, 28750 sayılı Çalışan Temsilcisi Tebliği ve 28681 sayılı Acil Durumlar Yönetmeliği maddeleri esas alınmıştır.',
    },
    {
      question: 'İşe başlama eğitimi yüz yüze zorunlu mu?',
      answer:
        '02.04.2026 tarihli 33212 sayılı yönetmelik gereği işe başlama eğitiminin tamamı yüz yüze yapılmalıdır. Tekrar eğitimleri en az 8 ders saatidir; işe ve işyerine özgü konular Tehlikeli sınıfta 3, Çok Tehlikeli sınıfta 4 ders saati yüz yüze verilir, kalan kısım uzaktan veya karma yöntemle verilebilir (Md 12/3, 13/3, 14/2).',
    },
  ],
  seo: {
    title: 'Yasal Yükümlülük Hesaplayıcı 2026 | Riskmatik',
    description:
      '6331 + 33212 sayılı 2026 yönetmelik uyumlu yasal yükümlülük hesaplayıcı. İş güvenliği uzmanı sınıfı, çalışan temsilcisi, İSG kurulu, eğitim periyotları, yıllık adam-saat. Ücretsiz.',
    keywords:
      'yasal yükümlülük hesaplayıcı, isg uzmanı sınıfı, çalışan temsilcisi, isg kurulu, eğitim adam saat, 33212 yönetmelik',
    canonicalPath: '/araclar/yasal-yukumluluk-hesaplayici',
    featureList: [
      "Çalışan sayısı ve tehlike sınıfına göre temel İSG yükümlülüklerini hesaplama",
      "Gerekli iş güvenliği uzmanı sınıfı (İş Güvenliği Uzmanları Yön. Md 7)",
      "Çalışan temsilcisi sayısı (28750 Md 7)",
      "İSG kurulu zorunluluğu ve toplantı sıklığı (28532 Md 4 ve Md 9)",
      "Risk değerlendirmesi yenileme periyodu (6/4/2 yıl) ve tatbikat sıklığı (yılda en az 1)",
      "Temel eğitim süresi (8/12/16 ders saati), işe başlama eğitimi ve tekrar eğitimi periyodu (33212 Md 7, 13, 14)",
      "Yıllık eğitim adam-saat tahmini",
      "Her sonucun altında dayanak yönetmelik ve madde",
      "Ücretsiz, kayıt gerektirmez",
    ],
    lastmod: '2026-08-08',
    priority: '0.85',
    changefreq: 'monthly',
  },
  order: 20,
  enabled: true,
  launchedAt: '2026-04-15',
  topics: ['yasal-yukumluluk', '6331', 'calisan-sayisi', 'isg-uzmani', 'calisan-temsilcisi', 'isg-kurulu', 'tehlike-sinifi', 'egitim-suresi', 'periyot-hesap', 'isveren-yukumluluk'],
  intent: 'hesap',
  spamCapacity: 5,
  bridge: {
    href: '/isg-yazilimi',
    etiket: 'Bu yükümlülükleri tek platformda nasıl yönettiğimizi görün',
  },
};

export default manifest;
